export default __webpack_public_path__ + "static/media/BTC.27c9c5ca.svg";